import React from "react";
import { View } from "react-native";
import { Text, Button, useTheme } from "react-native-paper";
import { useSelector } from "react-redux";
import OnlySingleStudent from "../components/OnlySingleStudent";
import {
    doc,
    getFirestore,
    writeBatch
} from "firebase/firestore";
import Global from "../constants/global";
import Preferance from "../constants/Preferances";
import * as Network from "expo-network";
import { FlatList } from "react-native-gesture-handler";



// ✅ Fixed props destructuring
const Timmer = ({ limit, clr }) => {
    const [secondsPassed, setSecondsPassed] = React.useState(0);
    const clearT = React.useRef(null);

    const timeLeft = limit - secondsPassed;

    React.useEffect(() => {
        const timer = setInterval(() => {
            setSecondsPassed(sp => sp + 1);
        }, 1000);

        clearT.current = timer;
        return () => clearInterval(timer);
    }, []);

    React.useEffect(() => {
        if (secondsPassed > limit) {
            clearInterval(clearT.current);
            clr();
        }
    }, [secondsPassed, limit, clr]);

    return (
        <Text style={{ flex: 1, textAlign: "center" }}>
            Wait {timeLeft}
        </Text>
    );
};

async function checkNet() {
    const res = await Network.getNetworkStateAsync();
    return res.isConnected && res.isInternetReachable;
}

const SaveButton = React.memo(({ navigation, focus }) => {
    const db = getFirestore(); // ✅ moved outside
    const [saveWorking, setSaveWorking] = React.useState({
        mess: "",
        len: 0,
        working: false,
        timmer: false,
        entry: []
    });

    const dump = useSelector(s => s.list.ExamDump);

    React.useEffect(() => {
        setSaveWorking(p => ({ ...p, entry: dump }));
    }, [dump]);

    const save = React.useCallback(async () => {
        const isConnected = await checkNet();
        if (!isConnected) {
            alert("Internet Connection issue");
            return;
        }

        setSaveWorking(p => ({ ...p, mess: "Preparing...", working: true }));

        const batch = writeBatch(db);

        try {
            const { year, exam, std, subject } = focus;

            const baseSubject = { ...subject };
            delete baseSubject.absent;
            delete baseSubject.attend;
            delete baseSubject.fail;
            delete baseSubject.left;
            delete baseSubject.pass;
            delete baseSubject.pending;

            const totalLen = saveWorking.entry.length;

            for (let ii = 0; ii < totalLen; ii++) {
                try {
                    const d = saveWorking.entry[ii];

                    const id = Global.StudentExamYearId({
                        student_id: d.student_id,
                        std,
                        exam,
                        year
                    });

                    const sid = id + subject.id;

                    const t = d?.theory || 0;
                    const p = d?.practical || 0;
                    const i = d?.internal || 0;

                    const data = {
                        id: sid,
                        eid: id,
                        studentId: d.student_id,
                        subjectId: d.subject_id,
                        stdId: std?.id,
                        year,
                        examId: exam.name,
                        theory: t,
                        practical: p,
                        internal: i,
                        status: Global.getPassFail(
                            t + p + i,
                            subject.totalMarks
                        ),
                        subject: baseSubject
                    };

                    const ref = doc(db, Global.MARKS, sid);
                    batch.set(ref, data, { merge: true });

                    // ✅ throttled UI update
                    if (ii % 10 === 0) {
                        setSaveWorking(p => ({
                            ...p,
                            mess: `Preparing ${ii}/${totalLen}`,
                            len: totalLen
                        }));
                    }

                } catch (e) {
                    //console.log("loop error", e); // ✅ no silent fail
                }
            }

            await batch.commit();
            navigation.goBack();

        } catch (w) {
            //console.log("err 4", w);
            alert("Error : 104");
        }
    }, [focus, saveWorking.entry, navigation]);

    const handleSave = React.useCallback(() => {
        if (!saveWorking.working) save();
    }, [saveWorking.working, save]);

    return (
        <View style={{ marginBottom: 60, flexDirection: "row" }}>
            <Button
                disabled={saveWorking.working}
                onPress={navigation.goBack}
                style={{ flex: 1 }}
            >
                Back
            </Button>

            <View style={{ flex: 1 }}>
                <Text style={{ textAlign: "center" }}>
                    {saveWorking.working ? "Wait, Donot Press Back Button" : ""}
                </Text>
                <Text style={{ textAlign: "center" }}>
                    {saveWorking.mess}
                </Text>

                <Button
                    loading={saveWorking.working}
                    onPress={handleSave}
                    mode="contained"
                >
                    Save
                </Button>
            </View>
        </View>
    );
});

export default function MarksEntry({ navigation, route }) {
    const [focus, setFocus] = React.useState({
        exam: undefined,
        subject: undefined,
        student: [],
        entry: [],
        year: 0,
        OriginalMarks: []
    });

    const marks = useSelector(s => s.list.Marks);

    const { exam, subject, std, students, year, allExams } = route.params;

    const clNo = (std?.classNo + "").trim();
    const clDiv = std?.div?.trim();

    const reportLog = useSelector(
        s => s.list.ResultLogs[clNo + clDiv + year]
    );

    // ✅ optimized memo
    const nLog = React.useMemo(() => {
        if (!reportLog) return [];

        const tLog = [...reportLog] // ✅ avoid mutation
            .filter(Boolean)
            .sort((a, b) => a?.data?.stamp - b?.data?.stamp);

        const cLog = {};
        tLog.forEach(e => {
            cLog[e.data.id] = e;
        });

        return Object.values(cLog);
    }, [reportLog]);

    const theme = useTheme();
    const colors = theme.colors;

    React.useEffect(() => {
        setFocus(p => ({
            ...p,
            exam,
            subject,
            std,
            student: students,
            year
        }));
    }, [exam, subject, std, students, year]);

    const subjectId = subject?.id;

    const renderItem = React.useCallback(({ item }) => {
        const cid = Global.StudentExamYearId({
            student: item,
            exam,
            std,
            year
        });

        const sMarks = marks?.[cid]?.[cid + subjectId];

        return item ? (
            <OnlySingleStudent
                allExams={allExams}
                year={year}
                par={subject?.practical}
                int={subject?.internal}
                subject={subject}
                log={nLog}
                student={item}
                cid={cid}
                marks={sMarks}
                std={std}
                thisExam={exam}
            />
        ) : null;
    }, [marks, exam, std, year, subject, subjectId, nLog, allExams]);

    return (
        <View style={{ flex: 1, backgroundColor: colors.background }}>

            <Text style={{ marginLeft: 3, marginTop: 8, marginBottom: 8 }}>નોંધ : પ્રથમ પરીક્ષા [50] + દ્વિતીય પરીક્ષા [50] + આંતરિક [20] + વાર્ષિક પરીક્ષા [80] ÷ 2 = Final Result</Text>

            {marks && (
                <FlatList
                    data={students}
                    keyExtractor={(item) => item.id?.toString()}
                    renderItem={renderItem}
                    keyboardShouldPersistTaps="handled"
                    ListFooterComponent={
                        <SaveButton navigation={navigation} focus={focus} />
                    }
                />
            )}
        </View>
    );
}